export default "__VITE_ASSET__DYOCvBj0__"